export const randomInclusive = (t, a) => (
  (t = Math.ceil(t)),
  (a = Math.floor(a)),
  Math.floor(Math.random() * (a - t + 1)) + t
);
